module.exports = __webpack_public_path__ + "img/27.e8d1739e.jpg";